// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as RedirectRouteImport } from './routes/redirect'
import { Route as PostsRouteImport } from './routes/posts'
import { Route as DeferredRouteImport } from './routes/deferred'
import { Route as PathlessLayoutRouteImport } from './routes/_pathlessLayout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users.index'
import { Route as UsersUserIdRouteImport } from './routes/users.$userId'
import { Route as PostsIndexRouteImport } from './routes/posts.index'
import { Route as PostsPostIdRouteImport } from './routes/posts.$postId'
import { Route as PathlessLayoutNestedLayoutRouteImport } from './routes/_pathlessLayout/_nested-layout'
import { Route as PostsPostIdDeepRouteImport } from './routes/posts_.$postId.deep'
import { Route as PathlessLayoutNestedLayoutRouteBRouteImport } from './routes/_pathlessLayout/_nested-layout/route-b'
import { Route as PathlessLayoutNestedLayoutRouteARouteImport } from './routes/_pathlessLayout/_nested-layout/route-a'

const UsersRoute = UsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => rootRouteImport
          })
const RedirectRoute = RedirectRouteImport.update({
            id: '/redirect',path: '/redirect',getParentRoute: () => rootRouteImport
          })
const PostsRoute = PostsRouteImport.update({
            id: '/posts',path: '/posts',getParentRoute: () => rootRouteImport
          })
const DeferredRoute = DeferredRouteImport.update({
            id: '/deferred',path: '/deferred',getParentRoute: () => rootRouteImport
          })
const PathlessLayoutRoute = PathlessLayoutRouteImport.update({
            id: '/_pathlessLayout',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const UsersIndexRoute = UsersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UsersRoute
          })
const UsersUserIdRoute = UsersUserIdRouteImport.update({
            id: '/$userId',path: '/$userId',getParentRoute: () => UsersRoute
          })
const PostsIndexRoute = PostsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PostsRoute
          })
const PostsPostIdRoute = PostsPostIdRouteImport.update({
            id: '/$postId',path: '/$postId',getParentRoute: () => PostsRoute
          })
const PathlessLayoutNestedLayoutRoute = PathlessLayoutNestedLayoutRouteImport.update({
            id: '/_nested-layout',getParentRoute: () => PathlessLayoutRoute
          })
const PostsPostIdDeepRoute = PostsPostIdDeepRouteImport.update({
            id: '/posts_/$postId/deep',path: '/posts/$postId/deep',getParentRoute: () => rootRouteImport
          })
const PathlessLayoutNestedLayoutRouteBRoute = PathlessLayoutNestedLayoutRouteBRouteImport.update({
            id: '/route-b',path: '/route-b',getParentRoute: () => PathlessLayoutNestedLayoutRoute
          })
const PathlessLayoutNestedLayoutRouteARoute = PathlessLayoutNestedLayoutRouteARouteImport.update({
            id: '/route-a',path: '/route-a',getParentRoute: () => PathlessLayoutNestedLayoutRoute
          })





const PathlessLayoutNestedLayoutRouteChildren = {
  PathlessLayoutNestedLayoutRouteARoute: PathlessLayoutNestedLayoutRouteARoute,PathlessLayoutNestedLayoutRouteBRoute: PathlessLayoutNestedLayoutRouteBRoute
}

const PathlessLayoutNestedLayoutRouteWithChildren = PathlessLayoutNestedLayoutRoute._addFileChildren(PathlessLayoutNestedLayoutRouteChildren)



const PathlessLayoutRouteChildren = {
  PathlessLayoutNestedLayoutRoute: PathlessLayoutNestedLayoutRouteWithChildren
}

const PathlessLayoutRouteWithChildren = PathlessLayoutRoute._addFileChildren(PathlessLayoutRouteChildren)




const PostsRouteChildren = {
  PostsPostIdRoute: PostsPostIdRoute,PostsIndexRoute: PostsIndexRoute
}

const PostsRouteWithChildren = PostsRoute._addFileChildren(PostsRouteChildren)




const UsersRouteChildren = {
  UsersUserIdRoute: UsersUserIdRoute,UsersIndexRoute: UsersIndexRoute
}

const UsersRouteWithChildren = UsersRoute._addFileChildren(UsersRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,PathlessLayoutRoute: PathlessLayoutRouteWithChildren,DeferredRoute: DeferredRoute,PostsRoute: PostsRouteWithChildren,RedirectRoute: RedirectRoute,UsersRoute: UsersRouteWithChildren,PostsPostIdDeepRoute: PostsPostIdDeepRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)